import axios from 'axios';
import {
  FETCH_ASSETS_SUCCESS,
  FETCH_ASSETS_FAIL,
  FETCH_PAIRS_SUCCESS,
  FETCH_PAIRS_FAIL,
} from './types';

export const fetchAssets = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/public/assets';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_ASSETS_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_ASSETS_FAIL, errors: error });
    }

    return dispatch({ type: FETCH_ASSETS_FAIL });
  }
};

export const fetchPairs = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/public/pairs';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_PAIRS_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_PAIRS_FAIL, errors: error });
    }

    return dispatch({ type: FETCH_PAIRS_FAIL });
  }
};
